import React from 'react';

const Landbot = () => {
  return (
    <>
      <h5>
        <b> Land Bot</b>
      </h5>
      <p>
        The Landbot plugin lets you easily embed Landbot to your website which can make your website
        more engaging through highly-interactive chatbots.
      </p>
      <br />
    </>
  );
};

export default Landbot;
